// extracted by mini-css-extract-plugin
export var category = "TutorialCard-module--category--a523f";
export var content = "TutorialCard-module--content--526ba";
export var duration = "TutorialCard-module--duration--71c76";
export var footer = "TutorialCard-module--footer--58829";
export var placeholderThumbnail = "TutorialCard-module--placeholderThumbnail--e8cde";
export var playIcon = "TutorialCard-module--playIcon--64884";
export var playOverlay = "TutorialCard-module--playOverlay--e39e0";
export var root = "TutorialCard-module--root--dde18";
export var thumbnail = "TutorialCard-module--thumbnail--13199";
export var thumbnailWrapper = "TutorialCard-module--thumbnailWrapper--c4347";
export var title = "TutorialCard-module--title--61b0a";